/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import _range from 'lodash/fp/range';
import WMTSSource from 'ol/source/wmts';
import WMTSTileGrid from 'ol/tilegrid/wmts';
import { WMTS_FORMAT, WMTS_REQUEST_ENCODING, WMTS_VERSION, assert, extentHelper, tileGridHelper, tileSource } from '../core';

var props = {
  dimensions: Object,
  format: {
    type: String,
    default: WMTS_FORMAT
  },
  layerName: {
    type: String,
    required: true
  },
  matrixSet: {
    type: String,
    required: true
  },
  requestEncoding: {
    type: String,
    default: WMTS_REQUEST_ENCODING
  },
  styleName: {
    type: String,
    required: true
  },
  version: {
    type: String,
    default: WMTS_VERSION
  },
  url: {
    type: String,
    required: true
  }
};

var methods = {
  /**
   * @returns {ol.source.WMTS}
   * @protected
   */
  createSource: function createSource() {
    return new WMTSSource({
      attributions: this.attributions,
      cacheSize: this.cacheSize,
      crossOrigin: this.crossOrigin,
      dimensions: this.dimensions,
      format: this.format,
      layer: this.layerName,
      logo: this.logo,
      matrixSet: this.matrixSet,
      projection: this.projection,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      requestEncoding: this.requestEncoding,
      tileGrid: this._tileGrid,
      tilePixelRatio: this.tilePixelRatio,
      style: this.styleName,
      version: this.version,
      url: this.urlTmpl,
      wrapX: this.wrapX
    });
  },

  /**
   * @return {ol.tilegrid.WMTS}
   * @protected
   */
  createTileGrid: function createTileGrid() {
    assert.hasView(this);

    var extent = extentHelper.fromProjection(this.$view.getProjection());
    var resolutions = tileGridHelper.resolutionsFromExtent(extent, this.maxZoom, this.tileSize);

    return new WMTSTileGrid({
      extent: extent,
      resolutions: resolutions,
      tileSize: this.tileSize,
      minZoom: this.minZoom,
      matrixIds: _range(this.minZoom, resolutions.length)
    });
  }
};

var Source = {
  name: 'vl-source-wmts',
  mixins: [tileSource],
  props: props,
  methods: methods
};

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/wmts-source/index.es.js
// module id = null
// module chunks = 